export enum FilterOperator {
  Equals = 0,
  NotEquals = 1,
  Contains = 2,
  StartsWith = 3,
  In = 4,
  GreaterThan = 5,
  GreaterThanOrEquals = 6,
  LessThan = 7,
  LessThanOrEquals = 8,
  NotContains = 9,
}
